(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dyefor-grouped-collection-list"] && !Shopify.designMode) return;
  try {
    
setTimeout(() => {
  for(const link of document.querySelectorAll('dyefor-grouped-collection-list .dyefor-collection-groups a')){
    var gcl = link.closest('dyefor-grouped-collection-list');
    link.addEventListener('click', ()=>{
      if(!gcl){
        return;
      }

      let linkIndex = link.getAttribute('data-index');
      if(!linkIndex){
        return;
      } 

      for(const aLink of gcl.querySelectorAll('.dyefor-collection-groups a')){
        aLink.classList.remove('selected');
      }
      link.classList.add('selected');
      for(const sc of gcl.querySelectorAll('slider-component')){
        let scIndex = sc.getAttribute('data-index');
        if(scIndex === linkIndex){
          sc.classList.remove('hidden');
        }else{
          sc.classList.add('hidden');
        }
      }
    });
  }
}, 300);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const updateDyeforHeaderPanelPosition = (activeDetails = null) => {
    const section = document.querySelector('body.template-index #shopify-section-header, body.template-collection #shopify-section-header, body.template-product #shopify-section-header');
    const headerBar = section?.querySelector('.header-wrapper') || section?.querySelector('.header');
    if (!section || !headerBar) return;

    const rect = headerBar.getBoundingClientRect();
    const gutter = window.innerWidth < 750 ? 10 : 24;
    const details = activeDetails?.closest?.('details.mega-menu') || section.querySelector('.header__inline-menu details[open]');
    const summary = details?.querySelector('summary');
    const menuSize = details?.dataset.dyeforMenuSize || 'wide';
    let left = Math.max(gutter, rect.left);
    let width = Math.min(rect.width, window.innerWidth - left - gutter);

    if (summary && menuSize !== 'wide' && window.innerWidth >= 990) {
      const summaryRect = summary.getBoundingClientRect();
      const desiredWidth = menuSize === 'compact' ? 420 : 760;
      width = Math.min(desiredWidth, window.innerWidth - gutter * 2);
      left = summaryRect.left + summaryRect.width / 2 - width / 2;
      left = Math.min(Math.max(gutter, left), window.innerWidth - width - gutter);
    }

    document.documentElement.style.setProperty('--dyefor-header-panel-top', `${Math.round(rect.bottom + 10)}px`);
    document.documentElement.style.setProperty('--dyefor-header-panel-left', `${Math.round(left)}px`);
    document.documentElement.style.setProperty('--dyefor-header-panel-width', `${Math.round(width)}px`);
  };

  const setupDyeforDesktopMenuHover = () => {
    const section = document.querySelector('body.template-index #shopify-section-header, body.template-collection #shopify-section-header, body.template-product #shopify-section-header');
    if (!section) return;

    const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    section.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (menu.dataset.dyeforHoverMenu === 'true') return;
      menu.dataset.dyeforHoverMenu = 'true';

      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      if (!details || !summary) return;

      let closeTimer;

      const closeSiblings = () => {
        section.querySelectorAll('.header__inline-menu header-menu details[open]').forEach((openDetails) => {
          if (openDetails === details) return;
          openDetails.removeAttribute('open');
          openDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      };

      const openMenu = () => {
        if (!desktopHover.matches) return;
        window.clearTimeout(closeTimer);
        closeSiblings();
        updateDyeforHeaderPanelPosition(details);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!desktopHover.matches) return;
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 140);
      };

      summary.addEventListener('click', (event) => {
        if (!desktopHover.matches || event.detail === 0 || !details.hasAttribute('open')) return;
        event.preventDefault();
        window.clearTimeout(closeTimer);
        summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('focusin', openMenu);
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) closeMenu();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    updateDyeforHeaderPanelPosition();
    setupDyeforDesktopMenuHover();

    document.querySelectorAll('body.template-index #shopify-section-header .header__inline-menu details, body.template-collection #shopify-section-header .header__inline-menu details, body.template-product #shopify-section-header .header__inline-menu details').forEach((details) => {
      details.addEventListener('mouseenter', () => updateDyeforHeaderPanelPosition(details));
      details.addEventListener('focusin', () => updateDyeforHeaderPanelPosition(details));
      details.addEventListener('toggle', () => updateDyeforHeaderPanelPosition(details));
    });
  });

  window.addEventListener('resize', updateDyeforHeaderPanelPosition);
  window.addEventListener('scroll', updateDyeforHeaderPanelPosition, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
